import Component from '@glimmer/component';
import { service } from '@ember/service';
import { array } from '@ember/helper';
import { t } from 'ember-intl';
import PartnerReportsPage from 'tio-reporting/components/partner-reports-page';
import { Section, VStack } from 'tio-ui/components/layout';
import type FeaturesService from 'tio-common/services/features';
import type SessionContextService from 'tio-employee/services/session-context';

interface S {
  Args: {
    model: {
      id: string;
    };
  };
}

class ReportingIndexRoute extends Component<S> {
  @service declare features: FeaturesService;
  @service declare sessionContext: SessionContextService;

  get showPartnerReports() {
    return this.features.isEnabled('partnerReportListing');
  }

  get companyId() {
    return this.sessionContext.currentRole?.company.id;
  }

  <template>
    <VStack>
      {{#if this.showPartnerReports}}
        {{#if this.companyId}}
          <Section>
            <:header>{{t "reporting.reports"}}</:header>
            <:body>
              {{! This page lives under Tuition Assistance — only tas reports.
                  Other products (pslf, syf, …) arrive with a future
                  comprehensive reporting page. }}
              <PartnerReportsPage
                @companyId={{this.companyId}}
                @viewerRoute="authenticated.admin.reporting.report-viewer"
                @reportTypes={{array "tas"}}
              />
            </:body>
          </Section>
        {{/if}}
      {{/if}}
    </VStack>
  </template>
}

export default ReportingIndexRoute;
